import { Component, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { StyleService, SystemService } from 'libs/shared/src';
import { GsIconComponent } from 'libs/shared/src/components/gs-icon/gs-icon.component';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'header-topbar',
  imports: [CommonModule, TranslatePipe, GsIconComponent],
  templateUrl: './topbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      display: block;
    }
  `
})
export class TopbarComponent {
  protected readonly headerService = inject(HeaderService);
  protected readonly styleService = inject(StyleService);
  protected readonly system = inject(SystemService);

  /** Event emitted when topbar close button is clicked */
  public readonly closeTopbar = output<void>();

  /**
   * Handles the close button click
   */
  protected handleClose(): void {
    this.closeTopbar.emit();
  }
}
